import { render } from "./PausingVideoPlayer.vue?vue&type=template&id=80292020"
import script from "./PausingVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./PausingVideoPlayer.vue?vue&type=script&lang=ts"
script.render = render

export default script